import { render, staticRenderFns } from "./Index3.vue?vue&type=template&id=7179f715&scoped=true&"
import script from "./Index3.vue?vue&type=script&lang=js&"
export * from "./Index3.vue?vue&type=script&lang=js&"
import style0 from "./Index3.vue?vue&type=style&index=0&id=7179f715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179f715",
  null
  
)

component.options.__file = "Index3.vue"
export default component.exports